export default {
  // 導航欄目
  analysisResearch: "研判分析",
  evidenceManagement: "調證管理",
  dataBoard: "數據看板",
  caseToolbox: "辦案工具箱",
  helpCenter: "幫助中心",
  contactUs: "聯繫我們",

  // 研判分析子菜單
  caseAnalysis: "案件分析",
  balanceAnalysis: "餘額分析",
  labelManagement: "標籤管理",
  aiModel: "AI模型",
  addressMonitoring: "地址監控",

  // 調證管理子菜單
  evidenceAdvice: "調證建議",
  evidenceUsers: "調證用戶",
  evidenceUpload: "調證上傳",
  evidenceInvestigation: "調證協查",

  // 數據看板子菜單
  transactionData: "交易數據",
  balanceData: "餘額數據",

  // 辦案工具箱子菜單
  addressCompletion: "地址補全",
  hashCompletion: "哈希補全",
  tgSentimentAnalysis: "TG公群輿情分析",

  // 幫助中心子菜單
  productFunction: "產品功能介紹",
  judicialReference: "司法判例參考",
  prosecutionBook: "起訴書",
  policyRegulation: "政策法規",
  blockchainKnowledge: "區塊鏈行業知識",
  blockchainCaseInvestigation: "區塊鏈案件偵查實錄",

  // 聯繫我們
  wechatPublic: "微信公眾號",
  wechatService: "微信客服",
};
